import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import ErrorPageComponent from '../components/error/ErrorPage';
import { PrivilegeContext } from '../components/priviledge/PriviledgeProvider';
import { RootState } from '../redux/store';
import { FacilitatorAccessProfile, PermissionRequired } from '../type/menu-type';
import { canAccessFacilitatorDashboard } from '../utils/dashboardAccess';

interface ProtectedRouteProps {
  component: React.ComponentType;
  access: any | undefined;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, access }) => {

  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const tutor = useSelector((state: RootState) => state.tutor);
  const { userCan, isFacilitator, isFacilitatorManager } = useContext(PrivilegeContext)

  const errorAccessPage = <ErrorPageComponent />

  const hasAnyOfAccess = (permissions: PermissionRequired[]) => {
    return permissions.some((permission) => userCan(permission.action, permission.group, permission.isSuperAdmin || false));
  };

  const hasFacilitatorAccess = (profiles: FacilitatorAccessProfile[]) => {
    return profiles.some((profile) => {
      if (profile === 'facilitator_manager') {
        return isFacilitatorManager;
      }

      if (profile === 'facilitator') {
        return canAccessFacilitatorDashboard(userCan, { isFacilitator, isFacilitatorManager });
      }

      return false;
    });
  };

  const determineAccess = () => {
    const facilitatorAccessGranted = access?.facilitatorAnyOf ? hasFacilitatorAccess(access.facilitatorAnyOf) : false;
    const permissionAnyOfGranted = access?.anyOf ? hasAnyOfAccess(access.anyOf) : false;

    if (access?.anyOf && access?.facilitatorAnyOf && !permissionAnyOfGranted && !facilitatorAccessGranted) {
      return errorAccessPage;
    }

    if (!access?.facilitatorAnyOf && access?.anyOf && !permissionAnyOfGranted) {
      return errorAccessPage;
    }

    if (access?.action && !userCan(access.action, access.group) && !facilitatorAccessGranted) {
      return errorAccessPage;
    }

    return (component);
  };

  return (
    <>
      {(user && isAuthenticated) ? determineAccess() : null}
      {(tutor.tutor && tutor.isAuthenticated) ? determineAccess() : null}
      {(user && !isAuthenticated) ? <Navigate to="/" /> : null}
      {((!user && !isAuthenticated) && (!tutor.tutor && !tutor.isAuthenticated)) ? <Navigate to="/login" /> : null}
    </>
  );
};

export default ProtectedRoute;
